import MutationApi from '../remote/mutationApi'
const GENERIC_ERROR_MESSAGE = 'Failed to reopen tab'

export const reopenOrder = async (orderUuid) => {
  const result = await MutationApi.reopenOrder(orderUuid)
  const applied = result?.data?.orderMutations?.[0]?.applied

  if (result?.status !== 201) {
    throw new Error(GENERIC_ERROR_MESSAGE)
  }

  if (!applied) {
    throw new Error(result?.data?.orderMutations?.[0]?.friendlyMessage || GENERIC_ERROR_MESSAGE)
  }

  return result
}

export const retotalOrder = async (orderUuid, promotions, taxExempt, taxExemptReason, taxExemptApproverUuid) => {
  const result = await MutationApi.updateTotals({ orderUuid, promotions, taxExempt, taxExemptReason, taxExemptApproverUuid })
  const applied = result?.data?.orderMutations?.[0]?.applied

  //TODO check if we really want to stop processing and display bad toast here
  if (result?.status !== 201 || !applied) {
    throw new Error(GENERIC_ERROR_MESSAGE)
  }

  return result
}
